import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis, Legend } from "recharts";
import { useApi } from "../../lib/useApi";
import { Card, Kpi, pct } from "../stats/StatsParts";
import { COMPANY_STATUS, fmtDate } from "../../lib/labels";

const Ranking = ({ rows, label, testId }) => (
  <div className="overflow-x-auto"><table className="w-full text-sm" data-testid={testId}>
    <thead><tr className="text-left text-xs uppercase text-slate-500"><th className="py-2">{label}</th><th>Entreprises</th><th>Actives</th><th>Feedbacks</th></tr></thead>
    <tbody className="divide-y">{rows.slice(0, 10).map((r) => <tr key={r.name}><td className="py-2">{r.name}</td><td>{r.companies}</td><td>{r.active}</td><td>{r.feedbacks}</td></tr>)}</tbody>
  </table></div>
);

const merge = (a, b) => a.map((m, i) => ({ month: m.month, feedbacks: m.count, entreprises: b[i].count }));

export default function PlatformAnalytics() {
  const { data } = useApi("/admin/analytics");
  if (!data) return null;
  const f = data.feedbacks;
  const o = data.operations;
  return (
    <div className="mt-8 space-y-6" data-testid="platform-analytics">
      <div>
        <p className="font-display text-lg font-semibold">Statistiques agrégées</p>
        <p className="text-sm text-slate-500">Données réelles · période du {fmtDate(data.period.from, false)} au {fmtDate(data.period.to, false)} · {f.total} avis analysés au total.</p>
        {data.insufficient && <p className="mt-2 rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-900" data-testid="platform-insufficient">Données insuffisantes : moins de 5 avis sur la plateforme, les tendances ne sont pas représentatives.</p>}
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Kpi testId="plat-kpi-active30" label="Entreprises actives (30 j)" value={data.companies.active_last_30d} hint="ayant reçu au moins 1 avis" />
        <Kpi testId="plat-kpi-fb30" label="Avis (30 j)" value={f.last_30d} hint={`${f.total} au total`} />
        <Kpi testId="plat-kpi-avg" label="Note moyenne réseau" value={f.avg_rating} />
        <Kpi testId="plat-kpi-response" label="Taux de réponse réseau" value={pct(f.response_rate)} hint={`résolution ${pct(f.resolution_rate)}`} />
        <Kpi testId="plat-kpi-complaints" label="Réclamations ouvertes" value={f.open_complaints} />
        <Kpi testId="plat-kpi-qr" label="Scans QR" value={data.qr.scans} hint={`${data.qr.feedbacks_from_qr} avis via QR (scans ≠ avis)`} />
        <Kpi testId="plat-kpi-abuse" label="Signalements en attente" value={o.abuse_pending} hint={`${o.contact_new} message(s) de contact nouveaux`} />
        <Kpi testId="plat-kpi-reports" label="Rapports envoyés (30 j)" value={o.reports_sent_30d} hint={`${o.deletions_pending} suppression(s) en attente`} />
      </div>
      <Card title="Tendances sur 12 mois" testId="plat-monthly">
        <div className="h-60"><ResponsiveContainer width="100%" height="100%">
          <LineChart data={merge(data.monthly_feedbacks, data.monthly_companies)}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
            <XAxis dataKey="month" tick={{ fontSize: 11 }} /><YAxis allowDecimals={false} width={30} tick={{ fontSize: 11 }} /><Tooltip /><Legend />
            <Line dataKey="feedbacks" name="Avis soumis" stroke="#4F46E5" strokeWidth={2} />
            <Line dataKey="entreprises" name="Nouvelles entreprises" stroke="#059669" strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer></div>
      </Card>
      <div className="grid gap-6 lg:grid-cols-3">
        <Card title="Entreprises par statut" testId="plat-status">
          <div className="h-48"><ResponsiveContainer width="100%" height="100%">
            <BarChart data={Object.entries(COMPANY_STATUS).map(([k, v]) => ({ label: v.label, n: data.companies.by_status[k] || 0 }))}>
              <XAxis dataKey="label" tick={{ fontSize: 10 }} interval={0} /><YAxis allowDecimals={false} width={24} /><Tooltip /><Bar dataKey="n" name="Entreprises" fill="#4F46E5" radius={[4, 4, 0, 0]} />
            </BarChart>
          </ResponsiveContainer></div>
        </Card>
        <Card title="Secteurs" testId="plat-sectors"><Ranking rows={data.sectors} label="Secteur" testId="plat-sectors-table" /></Card>
        <Card title="Pays" testId="plat-countries"><Ranking rows={data.countries} label="Pays" testId="plat-countries-table" /></Card>
      </div>
    </div>
  );
}
